import  { FC, } from "react";
import { Col, Row, Typography, Form } from "antd";
import useMazakaForm from "hooks/useMazakaForm";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaTextArea } from "apps/Common/MazakaTextarea";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "../ServerSideStates";
import GeneralAdvertComplaintReason from "apps/Common/ComplaintReasones/ComplainByAdvertReasons";
import { complaintByUser } from "apps/CustomerPanel/Message/Services";

const ComplaintForm:FC<{onFinish:any}> = ({onFinish}) => {
  const { Text } = Typography;
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
  const [searchParams] = useSearchParams();
    const advertId = searchParams.get("id");
    const advertDetails = useGetAdvertDetails(advertId);
    const data = advertDetails?.data?.data


  const handleOnFinish = async() => {
    mazakaForm.setLoading()
    let formValues = form.getFieldsValue()
    formValues["description"] = formValues["description"]||""
    formValues["advertId"] = advertId
    formValues["complainerUserId"]=userInfoes.id
    formValues["reportedUserId"]=data?.userId
    try {
        await complaintByUser(formValues)
      mazakaForm.setSuccess(2000,()=>"İşlem Başarılı")
      openNotificationWithIcon("default","Şikayetiniz değerlendirmeye gönderildi")
      onFinish()
    } catch (error:any) {
      mazakaForm.setFailed(2000,error?.message)
    }
  };

  return (
    <Col xs={24}>
      <Row gutter={[0, 20]}>
        <Col xs={24} className="!flex justify-center">
          <Text className="!text-balack !font-bold !text-2xl">
            Lütfen şikayet nedeninizi belirtiniz
          </Text>
        </Col>
        <Col xs={24}>
          <MazakaForm
            submitButtonXPosition="left"
            form={form}
            onFinish={handleOnFinish}
            {...formActions}
          >
            <Row>
              <GeneralAdvertComplaintReason
              name={"reportId"}
              label="Şikayet Sebebiniz"
              placeholder="Şikayet Sebebiniz"
              xs={24}
              rules={[{ required: true, message: "" }]}
              
              />
              <MazakaTextArea
                      xs={24}
                      label="Detaylı bilgi için açıklama giriniz."
                      placeholder="Şikayetiniz ile ilgili açıklamanızı buraya yazabilirsiniz..."
                      name="description"
                      rules={[{ required: true, message: "" }]}
                    />
              
             
            </Row>
          </MazakaForm>
        </Col>
      </Row>
    </Col>
  );
};

export default ComplaintForm;
